import React from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';

export const fmtCve = (v) => `${Number(v || 0).toLocaleString('pt-PT')} CVE`;
export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString('pt-PT') : '—');
export const toInputDate = (d) => (d ? new Date(d).toISOString().slice(0, 16) : '');

export const rewardLabel = (kind, value, t) => (
  kind === 'percent' ? `-${value}%`
    : kind === 'fixed' ? `-${fmtCve(value)}`
      : `+${value} ${t('adminCommerce.bonusCreditsShort')}`
);

export const Field = ({ label, hint, children, className = '' }) => (
  <label className={`block text-sm ${className}`}>
    <span className="font-medium text-slate-700">{label}</span>
    {children}
    {hint && <span className="block text-xs text-slate-500 mt-1">{hint}</span>}
  </label>
);

export const inputCls = 'mt-1 w-full h-10 px-3 rounded-md border border-slate-300 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500';

export const Toggle = ({ checked, onChange, label, testId }) => (
  <button
    type="button"
    onClick={() => onChange(!checked)}
    className={`inline-flex items-center gap-2 text-sm px-3 h-9 rounded-full border transition-colors ${checked ? 'bg-emerald-600 text-white border-emerald-600' : 'bg-white text-slate-700 border-slate-300'}`}
    data-testid={testId}
  >
    <span className={`h-2.5 w-2.5 rounded-full ${checked ? 'bg-white' : 'bg-slate-400'}`} />
    {label}
  </button>
);

export const ConfirmDialog = ({ open, title, body, onCancel, onConfirm, confirmLabel, cancelLabel, testId }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onCancel()}>
    <DialogContent data-testid={testId}>
      <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
      <p className="text-sm text-slate-600">{body}</p>
      <DialogFooter>
        <Button variant="outline" onClick={onCancel} data-testid="confirm-cancel-btn">{cancelLabel}</Button>
        <Button className="bg-rose-600 hover:bg-rose-700" onClick={onConfirm} data-testid="confirm-ok-btn">{confirmLabel}</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export const StatTile = ({ label, value, sub, testId }) => (
  <div className="rounded-xl border border-slate-200 bg-white p-4" data-testid={testId}>
    <p className="text-xs uppercase tracking-widest text-slate-500">{label}</p>
    <p className="text-2xl font-bold text-slate-900 mt-1">{value}</p>
    {sub && <p className="text-xs text-slate-500 mt-1">{sub}</p>}
  </div>
);
